import styled from "styled-components";

export const Btns = styled.div`
    display: inline-flex;

    .btn {
      background: #005a9e;
      color: #fff;
      margin-left: 4px;
    }
`;

export const FormContainer = styled.div`
     .form-content {
      display: flex;
    }

    .form-item {
      margin-right: 4px;
    }
`;
